import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Songs from './pages/Songs';
import Chart from './pages/Chart';
import './App.css';

function App() {
  return (
    <div className="App">
       <Routes>
          <Route path='/' element={<Songs />}></Route>
          <Route path='/Chart' element={<Chart />}></Route>
       </Routes>
    </div>
  );
}

export default App;